export const CCAA_ES = {
  'Andalucía': ['Almería', 'Cádiz', 'Córdoba', 'Granada', 'Huelva', 'Jaén', 'Málaga', 'Sevilla'],
  'Aragón': ['Huesca', 'Teruel', 'Zaragoza'],
  'Asturias': ['Asturias'],
  'Baleares': ['Illes Balears'],
  'Canarias': ['Las Palmas', 'Santa Cruz de Tenerife'],
  'Cantabria': ['Cantabria'],
  'Castilla y León': ['Ávila', 'Burgos', 'León', 'Palencia', 'Salamanca', 'Segovia', 'Soria', 'Valladolid', 'Zamora'],
  'Castilla-La Mancha': ['Albacete', 'Ciudad Real', 'Cuenca', 'Guadalajara', 'Toledo'],
  'Cataluña': ['Barcelona', 'Girona', 'Lleida', 'Tarragona'],
  'Comunidad Valenciana': ['Alicante', 'Castellón', 'Valencia'],
  'Extremadura': ['Badajoz', 'Cáceres'],
  'Galicia': ['A Coruña', 'Lugo', 'Ourense', 'Pontevedra'],
  'Madrid': ['Madrid'],
  'Murcia': ['Murcia'],
  'Navarra': ['Navarra'],
  'País Vasco': ['Álava', 'Guipúzcoa', 'Vizcaya'],
  'La Rioja': ['La Rioja'],
};

export const REGIONES_PT = {
  'Norte': ['Braga', 'Bragança', 'Porto', 'Viana do Castelo', 'Vila Real'],
  'Centro': ['Aveiro', 'Castelo Branco', 'Coimbra', 'Guarda', 'Leiria', 'Viseu'],
  'Lisboa e Vale do Tejo': ['Lisboa', 'Santarém', 'Setúbal'],
  'Alentejo': ['Beja', 'Évora', 'Portalegre'],
  'Algarve': ['Faro'],
  'Madeira': ['Madeira'],
  'Açores': ['Açores'],
};

export const TAMANOS = [
  { value: '', label: 'Todos los tamaños' },
  { value: 'pequeno', label: '≥ 5.000 hab' },
  { value: 'mediano', label: '≥ 20.000 hab' },
  { value: 'grande', label: '≥ 100.000 hab' },
  { value: 'muy_grande', label: '≥ 500.000 hab' },
];

export const LEYENDA_MAPA = [
  { color: '#22C55E', label: 'Contrato activo con gestora conocida' },
  { color: '#F59E0B', label: 'Contrato vence en <12 meses / conflicto SINAC' },
  { color: '#EF4444', label: 'Sin contrato o contrato vencido' },
  { color: '#3B82F6', label: 'Gestión directa municipal' },
  { color: '#6366F1', label: 'Gestora SINAC identificada (sin contrato)' },
  { color: '#9CA3AF', label: 'Sin datos suficientes' },
];
